module.exports = __webpack_public_path__ + "img/accessory_pants_05.1c586d55.svg";